var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-common-wrapper",attrs:{"id":"page-common-wrapper"}},[(_vm.$route.name !== 'project-detail')?_c('div',{staticClass:"project-bg",style:({
      backgroundColor: _vm.bg
    })}):_vm._e(),(_vm.$route.name !== 'upload-files')?_c('page-header'):_vm._e(),_c('router-view'),_c('horizontal-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }